export default __webpack_public_path__ + "static/media/jonah.90e866b4.jpeg";